import { useEffect, useState } from 'react';
import { authzApi } from '@core/api';
import { authStore } from '@core/stores';

/** Mirrors the project.manage relation used by project settings commands. */
export function useProjectManagePermission(projectId: string | undefined) {
  const profileId = authStore.activeProfileId;
  const key = `${profileId ?? ''}:${projectId ?? ''}`;
  const [result, setResult] = useState({ key: '', allowed: false });

  useEffect(() => {
    if (!profileId || !projectId) return;
    let active = true;
    authzApi.Check({ user: `profile:${profileId}`, relation: 'manage', object: `project:${projectId}` })
      .then((response) => { if (active) setResult({ key, allowed: response.allowed }); })
      .catch(() => { if (active) setResult({ key, allowed: false }); });
    return () => { active = false; };
  }, [key, profileId, projectId]);

  return { isLoading: !!profileId && !!projectId && result.key !== key, canManage: result.key === key && result.allowed };
}
